let currentFeedIdForMutePreference: string | null = null;
let hasManualVolumeOverrideForCurrentFeed = false;

const syncFeedSession = (feedId?: string | null): boolean => {
  const normalizedFeedId = feedId || null;
  const hasChanged = currentFeedIdForMutePreference !== normalizedFeedId;

  if (hasChanged) {
    currentFeedIdForMutePreference = normalizedFeedId;
    hasManualVolumeOverrideForCurrentFeed = false;
  }

  return hasChanged;
};

export const rememberManualVolumeOverrideForFeed = (
  feedId: string | null | undefined,
  volume: number,
) => {
  syncFeedSession(feedId);
  hasManualVolumeOverrideForCurrentFeed = volume > 0;
};

export const shouldApplyMutePreferenceForFeed = (
  feedId?: string | null,
): boolean => {
  syncFeedSession(feedId);
  return !hasManualVolumeOverrideForCurrentFeed;
};
